import styled from "styled-components";
import { A, MobileA } from "styles/elements";
import { FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const TrackHeaderContainer = styled(FlexRow)`
  padding: ${Theme.bigPanelPadding};
  align-items: flex-start;

  @media (max-width: 700px) {
    padding: ${Theme.smallPanelPadding};
  }

  @media (max-width: 450px) {
    flex-direction: column;
    align-items: stretch;
    row-gap: 15px;
  }
`;

export const TrackHeaderBodyContainer = styled(FlexColumn)`
  justify-content: flex-start;
  flex-grow: 1;
  margin-left: ${Theme.bigPanelPaddingHorizontal};
  row-gap: 25px;

  @media (max-width: 700px) {
    margin-left: ${Theme.smallPanelPadding};
    row-gap: 12px;
  }
`;

export const TrackHeaderNameRow = styled(FlexRow)`
  @media (max-width: 700px) {
    justify-content: center;
  }
`;

export const TrackHeaderStatsContainer = styled(FlexColumn)`
  row-gap: 15px;
  font-size: 12pt;

  @media (max-width: 700px) {
    row-gap: 12px;
    font-size: 11pt;
  }

  @media (max-width: 450px) {
    row-gap: 6px;
  }
`;

export const TrackHeaderStatsRow = styled(FlexRow)`
  column-gap: 20px;

  @media (max-width: 700px) {
    flex-direction: column;
    row-gap: 12px;
  }

  @media (max-width: 450px) {
    row-gap: 8px;
  }
`;

export const DesktopSpan = styled.span`
  @media (max-width: 700px) {
    display: none;
  }
`;

export const MobileSpan = styled.span`
  @media (min-width: 700px) {
    display: none;
  }
`;

export const TrackImageContainer = styled(FlexColumn)`
  max-height: 100%;
  max-width: 100%;
  align-items: stretch;
  align-self: center;

  @media (max-width: 450px) {
    max-width: 75%;
    margin: auto;
  }
`;

export const TrackImage = styled.img`
  overflow: hidden;
  width: 225px;

  @media (max-width: 700px) {
    width: 175px;
  }

  @media (max-width: 450px) {
    width: 100%;
    margin: auto;
  }
`;

export const TrackName = styled.span`
  font-size: 25pt;
  font-weight: 500;

  @media (max-width: 700px) {
    font-size: 20pt;
  }
`;

export const DesktopTmioButton = styled(A)`
  margin-top: 8px;
  margin-left: auto;
  font-size: 11.5pt;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const MobileTmioButton = styled(MobileA)`
  margin-top: 6px;
  text-align: center;
  padding: 5px 0;

  @media (min-width: 700px) {
    display: none;
  }

  @media (max-width: 450px) {
    font-size: 10pt;
  }
`;
